import { IApiActionResult } from "src/~api/ApiActionResult";
import { IContact } from "../~store/models/Contact";
import { getApiActionResult, fetchGet, fetchPost } from "src/~api/ApiHelper";

import {
    GET_CONTACTS_API_ROUTE,
    GET_CONTACTS_BY_TAG_API_ROUTE, 
    GET_CONTACT_MESSENGERS_API_ROUTE, 
    SAVE_CONTACT_API_ROUTE,
    DELETE_CONTACT_API_ROUTE,
    GET_CONTACT_BY_ID_API_ROUTE,
    FIND_CONTACT_BY_PHONE_API_ROUTE,
    SAVE_CONTACT_AVATAR_API_ROUTE,
    MERGE_CONTACTS_API_ROUTE, SAVE_ACCOUNT_API_ROUTE, DELETE_ACCOUNT_BY_ID_API_ROUTE, RESTORE_CONTACT_API_ROUTE, DETACH_MESSENGER_API_ROUTE, NEW_CHAT_WITH_MESSENGER_API_ROUTE,
    GET_ACCOUNT_TYPE_API_ROUTE,
    SAVE_MESSENGER_API_ROUTE,
} from "./apiRoutes";

import { IMessenger } from "../~store/models/Messenger";
import { IAccount } from "../~store/models/Account";
import { IChat } from "../../chats/~store/models/Chat";
import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { toApiSearchingTags } from "src/app/shared/helpers/api-body-helper/searchInputHelper";
import { ChatType } from "src/app/chats-panel/~store/models/enums/ChatType";

export const getContactsByTagsAsync = async (skip: number, count: number, searchingTags: ISearchingTag[], isSortingByContactLastName: boolean, skipEmpty: boolean): Promise<IApiActionResult<IContact[]>> => {
    const fetchPromise = fetchPost(GET_CONTACTS_BY_TAG_API_ROUTE, {
        body: JSON.stringify({
            skip,
            count,
            tags: toApiSearchingTags(searchingTags),
            isSortingByContactLastName,
            skipEmpty,
            withDeleted: false
        })
    });
    return await getApiActionResult(fetchPromise, true);
};

export const getContactsAsync = async (skip: number, count: number, searchString: string | undefined, isSortingByContactLastName: boolean, skipEmpty: boolean): Promise<IApiActionResult<IContact[]>> => {
    const fetchPromise = fetchGet(GET_CONTACTS_API_ROUTE + 
        "skip=" + skip + 
        "&count=" + count + 
        "&searchString=" + searchString + 
        "&withDeleted=" + false + 
        "&isSortingByContactLastName=" + isSortingByContactLastName +
        "&skipEmpty=" + skipEmpty);
    return await getApiActionResult(fetchPromise, true);
};

export const getContactMessengersAsync = async (contactId: number): Promise<IApiActionResult<IMessenger[]>> => {
    const fetchPromise = fetchGet(GET_CONTACT_MESSENGERS_API_ROUTE + contactId);
    return await getApiActionResult(fetchPromise, true);
};

export const saveContactAsync = async (newContact: IContact): Promise<IApiActionResult<IContact>> => {
    const fetchPromise = fetchPost(SAVE_CONTACT_API_ROUTE, {
        body: JSON.stringify({data: newContact}),
    });
    return await getApiActionResult(fetchPromise, true);
};

export const deleteContactAsync = async (contactId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(DELETE_CONTACT_API_ROUTE + contactId, {});
    return await getApiActionResult(fetchPromise, false); 
}

export const getContactByIdAsync = async (contactId: number): Promise<IApiActionResult<IContact>> => {
    const fetchPromise = fetchGet(GET_CONTACT_BY_ID_API_ROUTE + contactId);
    return await getApiActionResult(fetchPromise, true);
}

export const findContactByPhoneAsync = async (phone: string): Promise<IApiActionResult<IContact>> => {
    const fetchPromise = fetchGet(FIND_CONTACT_BY_PHONE_API_ROUTE + phone);
    return await getApiActionResult(fetchPromise, true);
}

export const changeContactAvatarAsync = async (avatarId: string | null, contactId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(SAVE_CONTACT_AVATAR_API_ROUTE, {
        body: JSON.stringify({
            avatarId,
            contactId,
        })
    });
    return await getApiActionResult(fetchPromise, false);
}

export const mergeContactsAsync = async(destContact: IContact, sourceContactId: number): Promise<IApiActionResult<IContact>> => {
    const fetchPromise = fetchPost(MERGE_CONTACTS_API_ROUTE, {
        body: JSON.stringify({
            destContact,
            sourceContactId,
        })
    });
    return await getApiActionResult(fetchPromise, true);
}

export const saveAccountAsync = async(account: IAccount): Promise<IApiActionResult<IAccount>> => {
    const fetchPromise = fetchPost(SAVE_ACCOUNT_API_ROUTE, {
        body: JSON.stringify({
            data: account
        })
    });

    return await getApiActionResult(fetchPromise, true);
}

export const deleteAccountAsync = async(accountId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(DELETE_ACCOUNT_BY_ID_API_ROUTE + accountId);

    return await getApiActionResult(fetchPromise, true);
}

export const restoreContactAsync = async(contactId: number): Promise<IApiActionResult<IContact>> => {
    const fetchPromise = fetchPost(RESTORE_CONTACT_API_ROUTE + contactId);

    return await getApiActionResult(fetchPromise, true);
}

export const detachMessengerAsync = async(messengerId: number, contactId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchPost(DETACH_MESSENGER_API_ROUTE + messengerId + "&contactId=" + contactId);

    return await getApiActionResult(fetchPromise, false);
}

export const newChatWithMessengerAsync = async (messengerId: number, contactId: number, templateName?: string, chatType: ChatType = ChatType.Private, 
    lastChatId: number | null = null): Promise<IApiActionResult<IChat>> => {
    const fetchPromise = fetchPost(NEW_CHAT_WITH_MESSENGER_API_ROUTE, {
        body: JSON.stringify({
            "messengerId": messengerId,
            contactId,
            "chatType": chatType,
            "lastChatId": lastChatId,
            "templateName": templateName
        })
    });
    return await getApiActionResult(fetchPromise, true);
}

export const getAccountTypesAsync = async (): Promise<IApiActionResult<string[]>> => {
    const fetchPromise = fetchGet(GET_ACCOUNT_TYPE_API_ROUTE);
    return await getApiActionResult(fetchPromise, true);
}

export const saveMessengerAsync = async (messenger: IMessenger, contactId: number): Promise<IApiActionResult<IMessenger>> => {
    const fetchPromise = fetchPost(SAVE_MESSENGER_API_ROUTE, {
        body: JSON.stringify({
            "messenger": messenger,
            contactId
        })
    });
    return await getApiActionResult(fetchPromise, true);
}
